import PropTypes from 'prop-types';
import React from 'react';

import { Box } from 'Components/Base';

const ASPECT_RATIO = 9 / 16;
const MAX_HEIGHT = '100vh';
const CONTENT_GAP = '270px'; // including top, bottom, margin, padding, subsection's title

const DefaultVideoWrapper = ({ children, ...restProps }) => {
  return (
    <Box
      mx={'auto'}
      style={{ maxWidth: `calc((1 / ${ASPECT_RATIO}) * ${MAX_HEIGHT})`, width: '100%' }}
      {...restProps}
    >
      <Box
        style={{
          paddingTop: `calc(${ASPECT_RATIO} * 100%)`,
          width: '100%',
          position: 'relative',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

const FixedSizeVideoWrapper = ({ children, ...restProps }) => {
  return (
    <Box
      mx={'auto'}
      style={{
        maxWidth: `max(calc((1 / ${ASPECT_RATIO}) * (${MAX_HEIGHT} - ${CONTENT_GAP})),1080px)`,
        width: '100%',
        height: '100%',
        position: 'relative',
        paddingBottom: `min(${ASPECT_RATIO * 100}%,calc(${MAX_HEIGHT} - ${CONTENT_GAP}))`,
      }}
      {...restProps}
    >
      {children}
    </Box>
  );
};

export const VIDEO_BOX_VARIANTS = {
  DEFAULT: 'DEFAULT',
  FIXED_SIZE: 'FIXED_SIZE',
};

const VIDEO_BOX_LAYOUT_COMPONENTS = {
  [VIDEO_BOX_VARIANTS.DEFAULT]: DefaultVideoWrapper,
  [VIDEO_BOX_VARIANTS.FIXED_SIZE]: FixedSizeVideoWrapper,
};

const VideoBoxWrapper = ({ children, variant }) => {
  const Wrapper =
    VIDEO_BOX_LAYOUT_COMPONENTS[variant] ?? VIDEO_BOX_LAYOUT_COMPONENTS[VIDEO_BOX_VARIANTS.DEFAULT];
  return <Wrapper>{children}</Wrapper>;
};

VideoBoxWrapper.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(Object.values(VIDEO_BOX_VARIANTS)),
};

VideoBoxWrapper.defaultProps = {
  variant: VIDEO_BOX_VARIANTS.DEFAULT,
};

export default VideoBoxWrapper;
